import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  callDownloadImage,
  callGetPublicCustomerVoucher,
  callGetPublicTenantsByChain,
} from 'helpers/api_helper';
import { callDownloadImages } from './../../helpers/api_helper';

export const getPublicTenantsByChain = createAsyncThunk(
  'public/callGetPublicTenantsByChain',
  async (param: string, { rejectWithValue }) => {
    try {
      const response = await callGetPublicTenantsByChain(param);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const getPublicCustomerVoucher = createAsyncThunk(
  'public/callGetPublicCustomerVoucher',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callGetPublicCustomerVoucher(param);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const downloadImage = createAsyncThunk(
  'customers/callDownloadImage',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callDownloadImage(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const downloadImages = createAsyncThunk(
  'customers/callDownloadImages',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callDownloadImages(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
